import React from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { ibanRegexp, swiftRegexp } from 'utils/helpers';
import { ValidationErrors } from 'constants/validations';
import { Col, Form, FormModal, Input, Row, Tooltip } from 'components';
import { useBankInformationEditeModal } from './useBankInformationEditeModal';

const { Item } = Form;

export interface IBankInformationEditeModal {
  modalState: boolean;
  onModalStateChange: () => void;
  dataToEdit?: Record<string, any>;
}

export const BankInformationEditeModal = (props: IBankInformationEditeModal) => {
  const { modalState, onModalStateChange, dataToEdit } = props;
  const { onFinish, onCancel, form, isLoading } = useBankInformationEditeModal({
    modalState,
    onModalStateChange,
    dataToEdit,
  });
  return (
    <FormModal
      form={form}
      title={'Update Bank Information'}
      width={680}
      okText={'Save'}
      open={modalState}
      isLoading={isLoading}
      onCancel={onCancel}
      onSubmit={onFinish}
    >
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Item
            name={'name'}
            label={'Bank Name*'}
            rules={[
              {
                required: true,
                message: ValidationErrors.required('Bank Name'),
              },
            ]}
          >
            <Input size={'large'} />
          </Item>
        </Col>
        <Col span={12}>
          <Item
            name={'accountName'}
            label={'Account Name*'}
            rules={[
              {
                required: true,
                message: ValidationErrors.required('Account Name'),
              },
            ]}
          >
            <Input size={'large'} />
          </Item>
        </Col>
        <Col span={12}>
          <Item
            name={'accountNumber'}
            label={'Account Number*'}
            rules={[
              {
                required: true,
                message: ValidationErrors.required('Account Number'),
              },
            ]}
          >
            <Input size={'large'} />
          </Item>
        </Col>
        <Col span={12}>
          <Item
            name={'swift'}
            label={'SWIFT Number'}
            rules={[{ pattern: swiftRegexp, message: 'Please enter a valid SWIFT number.' }]}
          >
            <Input
              size={'large'}
              suffix={
                <Tooltip title="Standard formats: NBADAEAD, NBADAEAD001, BOFAUS3N, CITIUS33XXX.">
                  <InfoCircleOutlined style={{ color: '#05796B' }} />
                </Tooltip>
              }
            />
          </Item>
        </Col>
        <Col span={12}>
          <Item name={'iban'} label={'IBAN'} rules={[{ pattern: ibanRegexp, message: 'Please enter a valid IBAN.' }]}>
            <Input
              size={'large'}
              suffix={
                <Tooltip title="Standard formats: AE070331234567890123456, AE750123456789012345678, ES9121000418450200051332, DE89370400440532013000.">
                  <InfoCircleOutlined style={{ color: '#05796B' }} />
                </Tooltip>
              }
            />
          </Item>
        </Col>
      </Row>
    </FormModal>
  );
};
